// extracted by mini-css-extract-plugin
export default {"LanguageSelect":"LanguageSelect_LanguageSelect__GKXC9","Arrow":"LanguageSelect_Arrow__-0z97"};